import { useTranslation } from "react-i18next";

const RangeSelectItem: React.FC<RangeSelectItemProps> = ({
  min,
  max,
  isRecommended,
  onSelect,
  isSelected,
}) => {
  const { i18n } = useTranslation();

  return (
    <div
      className="fixed-range-select-item"
      onClick={() => {
        onSelect();
      }}
    >
      <div className="fixed-range-label-container">
        <span className="fixed-range-label-min">{min}°C</span>
        <span className="fixed-range-label-max">{max}°C</span>
      </div>
      <div
        className={`fixed-range-box ${
          isSelected ? "fixed-range-box-selected" : ""
        }`}
      ></div>
      {!isRecommended && (
        <p className="fixed-range-not-recommended">
          {i18n.t("form_not_recommended_zone")}
        </p>
      )}
    </div>
  );
};

export default RangeSelectItem;

export interface RangeSelectItemProps {
  min: number;
  max: number;
  isRecommended: boolean;
  onSelect: () => void;
  isSelected: boolean;
}
